import React from 'react';
import { Tooltip } from '@mui/material';

interface ITariffChangeBadgeProps {
  // tariffMonitor.pendingChange from the Saved Work list query; absent once
  // the user has reviewed it.
  change?: {
    id?: string;
    heading?: string;
    previousValue?: string;
    currentValue?: string;
  } | null;
}

/** Saved Work list/card marker for a Tariff ticket with an unreviewed tariff update. */
const TariffChangeBadge: React.FC<ITariffChangeBadgeProps> = ({ change }) => {
  if (!change?.id) {
    return null;
  }
  const summary = change.heading
    ? `${change.heading}: ${change.previousValue ?? '—'} → ${change.currentValue ?? '—'}`
    : 'The tariff changed since this ticket was last reviewed';
  return (
    <Tooltip title={summary} arrow placement='top'>
      <span className='tariff-change-badge'>Tariff update</span>
    </Tooltip>
  );
};

export default TariffChangeBadge;
